import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = React.createElement("path", { d: "M3 5.969V21l18-9L3 3v2.969z" });
export default createSvgIcon(iconPath, "Play");
//# sourceMappingURL=PlayIcon.js.map